import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { WeldShopOverviewComponent } from './weld-shop-overview/weld-shop-overview.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'weld-shop',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    { path: 'overview', component: WeldShopOverviewComponent, data: { title: 'Weld Shop' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        WeldShopOverviewComponent
    ]
})
export class WeldShopModule {}
